import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LanguageService } from '../language/language.service';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class PagesService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  getPages(page: number = 1, perPage: number = 20, search: string = '') {
    const lang = this.languageService.getLanguage();
    let url = `${environment.apiUrl}admin/pages?lang=${lang}&page=${page}&perPage=${perPage}`;
    
    if (search && search.trim() !== '') {
      url += `&q=${encodeURIComponent(search)}`;
    }

    return this.http.get(url);
  }
  
  getPagesAll() {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/pages/all?lang=${lang}`);
  }
  
  createUpdate(data: any){
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/list/store?lang=${lang}`, data);
  }

  getGallery(id: number = 0) {
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/page/gallery?lang=${lang}&id=${id}`);
  }

  deletePage(id: number = 0){
    return this.http.post(`${environment.apiUrl}admin/delete/page`, { id });
  }

  checkSlug(slug: string, source: string = 'pages') {
    return this.http.get<{ exists: boolean }>(`${environment.apiUrl}admin/check-slug`, {
      params: { slug, source }
    });
  }

  getCategory(type: string){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}${type}?lang=${lang}`);
  }


   // Admin media: get gallery for list/news item
  getAdminGallery(itemId: number, lang: string = 'geo', ref_type: number = 1) {
    return this.http.get<any>(`${environment.apiUrl}admin/media`, {
      params: {
        item_id: itemId,
        lang,
        ref_type
      }
    });
  }

  // Admin media: attach uploaded file to item (creates art_media + art_media_ref)
  attachMedia(body: any) {
    return this.http.post<any>(`${environment.apiUrl}admin/media/attach`, body);
  }

  pinMedia(body: any) {
    return this.http.post<any>(`${environment.apiUrl}admin/media/pin`, body);
  }

  // Admin media: detach image from item (removes art_media_ref; can optionally delete the file if unused)
  detachMedia(body: { item_id: number; lang: string; ref_type: number; media_id: number; delete_file?: boolean }) {
    return this.http.post<any>(`${environment.apiUrl}admin/media/detach`, body);
  }

  // Admin: update attachment title (art_media_ref.media_title)
  updateAdminMediaTitle(payload: { item_id: number; lang: string; ref_type: number; media_id: number; title: string }) {
    return this.http.post<any>(`${environment.apiUrl}admin/media/title`, payload);
  }

reorderMedia(payload: { item_id: number; lang: string; ref_type: number; ordered_media_ids: number[] }) {
  return this.http.post<any>(`${environment.apiUrl}admin/media/reorder`, payload);
}


sortMedia(item_id: number, lang: string, ref_type: number, ids: number[]) {
  return this.http.post<any>(`${environment.apiUrl}admin/media/reorder`, {
    item_id,
    lang,
    ref_type,
    ordered_media_ids: ids
  });
}
}
